import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=e5fd86a2"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5fd86a2')) {
      api.createRecord('e5fd86a2', component.options)
    } else {
      api.reload('e5fd86a2', component.options)
    }
    module.hot.accept("./ThankYou.vue?vue&type=template&id=e5fd86a2", function () {
      api.rerender('e5fd86a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/ThankYou.vue"
export default component.exports